// Module
var code = "<p>Attendance: I cannot listen to your speech anymore. You seem to think that only your words are correct while others are incorrect. Do you want us to listen to you any more?</p> <p>Tathagata: Then do I have to tell lies? If I should tell lies about anything I will go back.</p> <p></p> ";
// Exports
module.exports = code;